"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interactionApiClient = void 0;
const data_lib_1 = require("@redbox-ruby/data-lib");
function interactionApiClient(networkClient) {
    return {
        createDemoRequest: async (body) => {
            return networkClient.postHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, "/api/v2/interactions/demo", body);
        },
        createSupportRequest: async (body) => {
            return networkClient.postHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, "/api/v2/interactions/support", body);
        },
        createContactRequest: async (body) => {
            return networkClient.postHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, "/api/v2/interactions/contact", body);
        },
        listActiveApplications: async (params) => {
            return networkClient.getHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, `/api/v2/interactions/team/${params.teamId}/apps`);
        },
        listActiveCountries: async (params) => {
            return networkClient.getHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, `/api/v2/interactions/team/${params.teamId}/countries`);
        },
        listActiveCampaigns: async (params) => {
            return networkClient.getHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, `/api/v2/interactions/team/${params.teamId}/active-campaigns`);
        },
        listAllSortedCampaigns: async (params) => {
            return networkClient.getHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, `/api/v2/interactions/team/${params.teamId}/campaign-listing-data`);
        },
        importStandaloneCampaign: async (params, body) => {
            return networkClient.postHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, `/api/v2/interactions/team/${params.teamId}/import-standalone-campaign`, body);
        },
        updateImportedCampaign: async (params) => {
            return networkClient.postHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, `/api/v2/interactions/team/${params.teamId}/campaign/${params.campaignId}/import-update`, {});
        },
        listEligibleCampaigns: async (params) => {
            return networkClient.getHttp(data_lib_1.INTERACTIONS_WEB_SERVICE, `/api/v2/interactions/team/${params.teamId}/eligible-campaigns-for-import`);
        },
    };
}
exports.interactionApiClient = interactionApiClient;
